import {
	requests
}from "../../../../api/agent"

export default {
	getPaged       : (params) => requests.getWithParams('/ReSpecificWeights/getPaged', params),
	getKinds       : (params) => requests.getWithParams('/ReSpecificWeights/getKinds', params),
	getList        : (params) => requests.getWithParams('/ReSpecificWeights/getList', params),
	upload         : (params) => requests.post('/ReSpecificWeights/upload', params),
	getExampleFile : () => requests.getFile('/ReSpecificWeights/getExampleFile')
}